App.controller('HomeCtrl', HomeCtrl);

function HomeCtrl() {
    //
}